import type { ApiResponse } from '../../types'
import type { CotMePerson, CreatePersonRequest, UpdatePersonRequest } from '../../types/community'
import { client, unwrap, apiError, CotApiError } from './client'

// COTC_SignupConsent owns the bodies. Foundation shipped the signatures.

/** GET /persons — people this family manages (withdrawn persons excluded server-side). */
export async function listPersons(): Promise<CotMePerson[]> {
  try {
    const res = await client.get<ApiResponse<CotMePerson[]>>('/persons')
    return unwrap(res.data)
  } catch (err) {
    if (err instanceof CotApiError) throw err
    throw apiError(err)
  }
}

/** POST /persons — add a managed person (guardian only). */
export async function createPerson(req: CreatePersonRequest): Promise<CotMePerson> {
  try {
    const res = await client.post<ApiResponse<CotMePerson>>('/persons', req)
    return unwrap(res.data)
  } catch (err) {
    if (err instanceof CotApiError) throw err
    throw apiError(err)
  }
}

/** PATCH /persons/{id} — change supervision (guardian only). */
export async function updatePerson(id: string, req: UpdatePersonRequest): Promise<CotMePerson> {
  try {
    const res = await client.patch<ApiResponse<CotMePerson>>(`/persons/${id}`, req)
    return unwrap(res.data)
  } catch (err) {
    if (err instanceof CotApiError) throw err
    throw apiError(err)
  }
}

/** DELETE /persons/{id} — withdrawal (soft-delete; not the account holder). */
export async function deletePerson(id: string): Promise<void> {
  try {
    const res = await client.delete<ApiResponse>(`/persons/${id}`)
    unwrap(res.data)
  } catch (err) {
    if (err instanceof CotApiError) throw err
    throw apiError(err)
  }
}
